import React from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import { PREVIEW_PARTS } from "../../constants/PlaybookBriefs";

import "./build-page.css";
import "./playbook-build-page.css";
import "./playbook-build-preview.css";

class PlaybookBuildPreview extends React.PureComponent {
	render() {
		const { preview } = this.props;
		const { name, description, parts, details, isFilling } = preview;
		const ringLabels = { done: "Done", partly: "Partly answered", waiting: "Not yet" };
		const headPart = PREVIEW_PARTS.find(part => part.key === "head");
		const hasName = !!name;
		const hasDescription = !!description;

		return (
			<section className="build-card tk-card playbook-build-preview">
				<div className="playbook-build-preview__head">
					<h3 className={clsx("playbook-build-preview__name", !hasName && "playbook-build-preview__name--untitled")}>
						{hasName ? name : "Untitled playbook"}
					</h3>
					<p className={clsx("playbook-build-preview__description", !hasDescription && "playbook-build-preview__description--empty")}>
						{hasDescription ? description : headPart.emptyText}
					</p>
				</div>

				<ol className="playbook-build-preview__parts">
					{parts.map(part => {
						const isDone = part.state === "done";
						const hasLines = part.lines.length > 0;
						const hasExtras = part.extras.length > 0;
						const isEmpty = !hasLines && !hasExtras;
						return (
							<li key={part.key} className={clsx("playbook-build-preview__part", `playbook-build-preview__part--${part.state}`)}>
								<span
									className={clsx("playbook-build-preview__ring", `playbook-build-preview__ring--${part.state}`)}
									role="img"
									aria-label={ringLabels[part.state]}
								>
									{isDone && <Icon.Check size={9} strokeWidth={3} aria-hidden="true" />}
								</span>
								<div className="playbook-build-preview__body">
									<span className="playbook-build-preview__label">{part.label}</span>
									{part.lines.map(line => (
										<div
											key={line.label}
											className={clsx("playbook-build-preview__line", line.isNotNeeded && "playbook-build-preview__line--not-needed")}
										>
											{line.isLabelShown &&<span className="playbook-build-preview__line-label">{line.label}</span>}
											<span className="playbook-build-preview__line-text">{line.text}</span>
										</div>
									))}
									{hasExtras && (
										<div className="playbook-build__tools playbook-build-preview__extras">
											{part.extras.map((extra, index) => (
												<span key={`${index}-${extra}`} className="playbook-build__tool">
													{extra}
												</span>
											))}
										</div>
									)}
									{isEmpty && <span className="playbook-build-preview__empty">{part.emptyText}</span>}
								</div>
							</li>
						);
					})}
				</ol>

				<dl className="playbook-build-preview__details">
					{details.map(detail => (
						<div key={detail.key} className="playbook-build-preview__detail">
							<dt>{detail.label}</dt>
							<dd>{detail.value}</dd>
						</div>
					))}
				</dl>

				{isFilling && (
					<p className="playbook-build-preview__foot">
						<Icon.MessageCircle size={13} aria-hidden="true" />
						This fills in as you talk to the guide.
					</p>
				)}
			</section>
		);
	}
}

export default PlaybookBuildPreview;
